import React from 'react';
import { bool, string, func, node, oneOfType } from 'prop-types';
import cx from 'classnames';

import Label from '../../Label';
import Message from '../../Message';

const propTypes = {
  /** Error state. If vaule is string, it's treated as error message. */
  error: oneOfType([bool, node]),
  /** Custom error renderer. Passes props as function parameter. */
  renderError: func,
  /** Label text. */
  label: string,
  /** Custom label renderer. Passes props as function parameter. */
  renderLabel: func,
  /** Help text. */
  help: string,
  /** Custom help renderer. Passes props as function parameter. */
  renderHelp: func,
};

const RadioCheckGroup = ({
  children,
  className,
  error,
  renderError,
  help,
  renderHelp,
  label,
  renderLabel,
  ...other
}) => {
  const classes = cx('radiocheck-group', className);

  const formControlClasses = cx('form-control', 'form-control--group');

  const groupLabel =
    (renderLabel && renderLabel(this.props)) ||
    (label && <Label isError={!!error}>{label}</Label>);

  const helpMessage =
    (renderHelp && renderHelp(this.props)) ||
    (help && <Message type="help">{help}</Message>);

  const errorMessage =
    (renderError && renderError(this.props)) ||
    (error &&
      typeof error === 'string' && <Message type="error">{error}</Message>);

  return (
    <div className={formControlClasses}>
      <div className={classes} {...other}>
        {groupLabel}
        {children}
        {helpMessage}
        {errorMessage}
      </div>
    </div>
  );
};

RadioCheckGroup.displayName = 'RadioCheckGroup';
RadioCheckGroup.propTypes = propTypes;

export default RadioCheckGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/RadioCheck/Group/Group.js